<div class="header-search-bar full-container">
  <div class="container-wrapper">
    <div class="d-flex justify-content-between track-ticket-wrapper">
      <a href="./">
        <img _ngcontent-rfy-c24="" src="https://images.5paisa.com/Campaign/5paisa-logo.svg" alt="5paisa Logo" title="5paisa Logo">
      </a>

      <!-- <span *ngIf="isLoggedIn == 'Y' && !showLoader" class="track-ticket" (click) = "clientPersonalDetails()">Track Ticket</span> -->
      <!-- <span *ngIf="isLoggedIn == 'Y'" class="track-ticket" onclick="openTicketsTab()">Track Ticket</span> -->
      <span *ngIf="isLoggedIn == 'Y'" class="track-ticket" (click)="openTicketAndCleverTapEvent()">Track Ticket</span>

      <div class="loading-text" *ngIf="showLoader" >
        <h1 class="loading">Loading
          <span class="dot-one"> .</span>
          <span class="dot-two"> .</span>
          <span class="dot-three"> .</span>
        </h1>
      </div>


    </div>
    
  <h1 class="fw-500 text">How can we help you?</h1>
  <div class="form-tab">
    <div class="search-field d-flex position-relative w-100">
      <span class="icon-search"></span>
      <form [formGroup]="searchForm" novalidate>
        <input autocomplete="off" type="text" pattern="^[a-zA-Z0-9?]*$" name="input" id="input" class="text-field"
          placeholder="Eg: how do i activate F&O ?" formControlName="searchText" (keyup)="searchByString()" (keypress)="omit_special_char($event)"/>
        <ul class="results" *ngIf="showResults">
          <li *ngFor="let item of searchListArray">
            <a *ngIf="item.title != ''" (click)="goTosubCategoryAnswers(item.id, item.category.id, item.permalink)">{{item.title}}</a>
            <a *ngIf="item == 'No results found'">{{item}}</a>
          </li>
        </ul>
      </form>
    </div>
  </div>
</div>
</div>